<div class="content-with-filled-button">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <p class="title pt-5 ">{{ copyService.copies.legal_req_characteristics.title }}</p>        
        <div>
            <ul class="botton-line" *ngFor="let item of legal_characteristics">
                <p class="subtitle my-4">{{ item.title }}</p>
                <vcl-list >
                    <li *ngFor="let item_list of item.dataSource" vclListSimple>
                        <span class="icon icon-itaufonts_chat_enviado"></span>
                        <vcl-list-text>
                            <span class="description-list" [innerHTML]="item_list"></span>
                        </vcl-list-text>
                    </li>
                </vcl-list>
            </ul>
        </div>
    </div>
</div>
<app-controls class="mt-5" [hasPrevious]="false" [nextLabel]="copyService.copies.legal_req_characteristics.continue" (next)="previous()"></app-controls>